<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">数据中心</el-breadcrumb-item>
        <el-breadcrumb-item>数据导出</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
  </div>
</template>

<script>
  export default {
    name: 'dataExport'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/dataExport.vue